import {useEffect, useState} from "react";
import {showPopUp} from "components/PopUp";
import RankPopup from "../RankPopup";
import View from "./View";
import {createRank, getSchoolRank} from "../techlympicApi";
import SchoolSelect from "../SchoolSelect";
import {useDispatch, useSelector} from "react-redux";
import {setGameState} from "store/actions/game";

export default function Container({schoolData, setSchoolData, dismiss}) {
  const dispatch = useDispatch();

  const [rankData, setRankData] = useState(null);
  const {gameState} = useSelector(state => state.game);

  useEffect(() => {
    if (schoolData && schoolData.school) {
      getRankData();
    }
  }, []);

  useEffect(() => {
    if (schoolData && schoolData.school) {
      getRankData();
    }
  }, [schoolData]);

  useEffect(() => {
    if (gameState === "GET_STAR") {
      createRankData();
    }
  }, [gameState]);

  useEffect(() => {
    if (schoolData && schoolData.school) {
      if (!rankData) {
        getRankData();
        return;
      }
    }
  }, [rankData]);

  const getRankData = async () => {
    const response = await getSchoolRank({school: schoolData.school});
    setRankData(response.data);
  };

  const createRankData = async () => {
    await createRank({zone: schoolData.zone, state: schoolData.state, school: schoolData.school, userPoint: 1});
    const response = await getSchoolRank({school: schoolData.school});
    setRankData(response.data);
    dispatch(setGameState("RESET"));
  };

  const rankBtnHandler = () => {
    getRankData();
    if (rankData) {
      showPopUp(<RankPopup rankData={rankData} schoolData={schoolData} />, {
        defaultPadding: false,
        transparentBackground: true,
        clearOverHidden: true,
      });
    } else {
      showPopUp(<RankPopup rankData={{school: schoolData.school, totalPoint: 0, ranking: "-"}} />, {
        defaultPadding: false,
        transparentBackground: true,
        clearOverHidden: true,
      });
    }
  };

  const setSchoolBtnHandler = () => {
    showPopUp(<SchoolSelect setSchoolData={setSchoolData} />, {
      defaultPadding: false,
      transparentBackground: true,
      clearOverHidden: true,
    });
  };

  if (!schoolData) {
    return (
      <View
        rank={"-"}
        point={0}
        schoolName={"-"}
        rankBtnHandler={rankBtnHandler}
        setSchoolBtnHandler={setSchoolBtnHandler}
        dismiss={dismiss}
      />
    );
  }

  if (rankData && rankData.ranking && rankData.totalPoint) {
    return (
      <View
        rank={rankData.ranking}
        point={rankData.totalPoint}
        schoolName={rankData.school}
        rankBtnHandler={rankBtnHandler}
        setSchoolBtnHandler={setSchoolBtnHandler}
        dismiss={dismiss}
      />
    );
  } else {
    return (
      <View
        rank={"No rank"}
        point={0}
        schoolName={schoolData.school}
        rankBtnHandler={rankBtnHandler}
        setSchoolBtnHandler={setSchoolBtnHandler}
        dismiss={dismiss}
      />
    );
  }
}
